import * as React from 'react';
import MHoldOrderView from '../layouts/MHoldOrderView';
// import { RowDataLive } from 'src/reducers/liveorderfile';
import { RowDataManufactur } from 'src/reducers/manufactur';
// import { UserDetail } from '../../reducers/user';

export interface MHoldOrderViewProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    mHoldOrderData: RowDataManufactur[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
    submitRework: (column: Object) => void;
}

class MHoldOrderPage extends React.Component<MHoldOrderViewProps> {
    render() {
        return (
            <MHoldOrderView
                onRowClick={this.props.onRowClick}
                mHoldOrderData={this.props.mHoldOrderData}
                reload={this.props.reload}
                onDownloadClick={this.props.onDownloadClick}
                submitRework={this.props.submitRework}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
        window.scrollTo(0, 0);
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default MHoldOrderPage;



// WEBPACK FOOTER //
// ./src/components/MHoldOrder/MHoldOrderPage.tsx